import { Edit3, Trash2, User } from 'lucide-react'
import { cn } from '@/utils/cn'
import type { TaskEffort } from '@/components/Configuracao/esforcoTimeTypes'

type Props = {
  tasks: TaskEffort[]
  searchQuery: string
  onClearSearch: () => void
  onEdit: (task: TaskEffort) => void
  onDelete: (id: string) => void
}

export function EsforcoTimeTaskTable({ tasks, searchQuery, onClearSearch, onEdit, onDelete }: Props) {
  return (
    <div className="glass-card overflow-hidden">
      {tasks.length === 0 ? (
        <div className="p-8 text-center space-y-2">
          <p className="text-sm text-text-muted">Nenhuma tarefa cadastrada nesta área.</p>
          {searchQuery && (
            <button type="button" onClick={onClearSearch} className="text-xs text-accent hover:underline">
              Limpar filtro de busca
            </button>
          )}
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-white/[0.06] bg-white/[0.01]">
                <th className="p-4 text-[10px] font-bold text-text-muted uppercase tracking-wider">
                  Tipo de tarefa
                </th>
                <th className="p-4 text-[10px] font-bold text-text-muted uppercase tracking-wider w-36">
                  Média de tempo / h
                </th>
                <th className="p-4 text-[10px] font-bold text-text-muted uppercase tracking-wider w-36">
                  Executor
                </th>
                <th className="p-4 text-[10px] font-bold text-text-muted uppercase tracking-wider w-24 text-right">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/[0.04]">
              {tasks.map((t) => (
                <tr key={t.id} className="hover:bg-white/[0.01] transition-colors group">
                  <td className="p-4 text-xs font-medium text-text-primary">{t.task}</td>
                  <td className="p-4 text-xs font-mono text-text-muted">{t.hours}</td>
                  <td className="p-4 text-xs">
                    <span
                      className={cn(
                        'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium',
                        t.executor === 'Gerencia'
                          ? 'bg-red-500/10 text-red-400 border border-red-500/20'
                          : 'bg-blue-500/10 text-blue-400 border border-blue-500/20',
                      )}
                    >
                      <User size={10} />
                      {t.executor}
                    </span>
                  </td>
                  <td className="p-4 text-xs text-right">
                    <div className="flex items-center justify-end gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      <button
                        type="button"
                        onClick={() => onEdit(t)}
                        className="p-1 rounded hover:bg-white/[0.06] text-text-muted hover:text-text-primary transition-colors"
                        title="Editar"
                      >
                        <Edit3 size={12} />
                      </button>
                      <button
                        type="button"
                        onClick={() => onDelete(t.id)}
                        className="p-1 rounded hover:bg-red-500/10 text-text-muted hover:text-red-400 transition-colors"
                        title="Excluir"
                      >
                        <Trash2 size={12} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
